'use strict';

var novicell = novicell || {};

novicell.header = novicell.header || new function () {

  this.init = function () {
    search();
    headerFixed();
    mobilesMenu();
  };

  function scrollLockMobileMenu(activate) {
    if (activate) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = '';
    }
  }

  /* Search toggle */
  function search() {
    let searchForm = document.querySelector('.js-header-search-form');
    let searchTrigger = document.querySelector('.js-header-search-trigger');
    if (searchForm && searchTrigger) {
      searchTrigger.addEventListener('click', function () {
        let input = searchForm.querySelector('input');
        searchForm.classList.toggle('header__search-form--active');
        if (searchForm.classList.contains('header__search-form--active')) {
          input.focus();
          searchForm.classList.remove('header__search-form--hide');
        }
        if (input.value.length > 0) {
          searchForm.classList.add('header__search-form--hide');
          searchForm.querySelector('form').submit();
        }
      });
    }
  }

  function animateHeader(header, logo, fromTop) {
    if (fromTop > header.offsetHeight) {
      header.classList.add('header--scrolling');
      if (header.classList.contains('header--hero')) {
        header.classList.remove('header--hero');
        logo.src = logo.dataset.logoBlue;
      }
    } else  {
      header.classList.remove('header--scrolling');
      let navMobileActivated = document.querySelector('.js-header-navigation').classList.contains('js-header-navigation-mobile-activated');
      if (!navMobileActivated && window.pageYOffset === 0 && header.dataset.headerHero === "1") {
        header.classList.add('header--hero');
        logo.src = logo.dataset.logoWhite;
      } else {
        header.classList.remove('header--hero');
        logo.src = logo.dataset.logoBlue;
      }
    }
  }

  /* Add transition for when user scroll down */
  function headerFixed() {
    let header = document.querySelector('.header');
    if (header && (!document.body.classList.contains('user--logged-in') && !document.body.classList.contains('path--user'))) {
      let animationTimer;
      let logo = header.querySelector('.logo');
      // Starting point and we have scrolled, then set/remove classes with new offset
      animateHeader(header, logo);
      window.onscroll = () => {
        let fromTop = window.pageYOffset;
        if (!window.requestAnimationFrame) {
          setTimeout((header, logo) => {
            animateHeader(header, logo, fromTop);
          }, 150, header, logo);
        } else {
          cancelAnimationFrame(animationTimer);
          animationTimer = window.requestAnimationFrame((timestamp) => {
            animateHeader(header, logo, fromTop);
          });
        }
      };
    }
  }

  function mobilesMenu() {
    let mobileTrigger = document.querySelector('#js-mobile-navigation-button');
    let headerNavigation = document.querySelector('.js-header-navigation');
    let header = document.querySelector('.header');
    if (header && mobileTrigger) {
      let logo = header.querySelector('.logo');
      mobileTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        mobileTrigger.classList.toggle('mobile-navigation-button--active');
        headerNavigation.classList.toggle('header__navigation--mobile-navigation');
        headerNavigation.classList.toggle('js-header-navigation-mobile-activated');
        /* Scroll Lock */
        let mobileMenuActive = mobileTrigger.classList.contains('mobile-navigation-button--active');
        scrollLockMobileMenu(mobileMenuActive);
        /* Remove hero styling on mobile click on hamburger icon */
        if (mobileMenuActive) {
          header.classList.remove('header--hero');
          logo.src = logo.dataset.logoBlue;
        } else if (window.pageYOffset === 0 && header.dataset.headerHero === "1") {
          header.classList.add('header--hero');
          logo.src = logo.dataset.logoWhite;
        }
      });
      /* Resize browser to set correct background color for what position user are in */
      window.addEventListener('resize', function () {
        if (headerNavigation.classList.contains('js-header-navigation-mobile-activated')) {
          if (document.body.clientWidth > 991) {
            headerNavigation.classList.remove('js-header-navigation-mobile-activated');
            if (typeof jQuery !== 'undefined') {
              scrollLockMobileMenu(false);
            }
          }
        } else {
          if (mobileTrigger.classList.contains('mobile-navigation-button--active') && document.body.clientWidth < 992) {
            headerNavigation.classList.add('js-header-navigation-mobile-activated');
            if (header.classList.contains('header--hero')) {
              header.classList.remove('header--hero');
              logo.src = logo.dataset.logoBlue;
            }
            if (typeof jQuery !== 'undefined') {
              scrollLockMobileMenu(true);
            }
          }
        }
        if (document.body.clientWidth > 991) {
          if (window.pageYOffset === 0 && header.dataset.headerHero === "1") {
            header.classList.add('header--hero');
            logo.src = logo.dataset.logoWhite;
          }
        }
      });
    }
  }
}();

Drupal.behaviors.topMenu = {
    attach: function (context, settings) {
        var nav = document.querySelector('.header__inner');
        if (settings.menuItems) {
            if (nav && settings.menuItems === 6) {
                nav.style.width = '85%';
            } else if (nav && settings.menuItems === 7) {
                nav.style.width = '90%';
            } else if (nav && settings.menuItems >= 8) {
                nav.style.width = '100%';
            }
        }
    }
};
